export const products = [
  {
    PN: "5-inch module",
    "Backlight Brightness": "150nits @ 855mW",
    "Display Mode": "VA / Reflective",
    "Reflectivity": "9%",
    "Display Size": "5.0 inch",
    "Dot Format": "720 x RGB x 1280",
    "Color Depth": "16.77M",
    "I/F": "MIPI",
    "Operating Temperature": "-20C to +70C",
    img: [require("../assets/Sharp-5-inch-R-IGZO.png")],
    "60Hz Panel Power": "< 150mW",
    DOCUMENTS: [],
    desc:
      "This 5.0-inch (diagonal) Reflective IGZO portrait-mode display is ideal for battery-powered, handheld products that require full-color and high-resolution performance in bright outdoor environments. The panel, built on Sharp’s industry-leading IGZO technology, offers ultra-low power consumption for both still and motion images, and allows for slim product profiles with reduced thermal management requirements. The MIPI interface display also delivers industrial strength operating temperature ranges. ",
  }
];
